import React from 'react'

const IconClock = props => (
  <svg
    className="icon"
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 7.39116V12.0664L14.1419 15.8184M20.25 12.0664C20.25 16.6228 16.5563 20.3164 12 20.3164C7.44365 20.3164 3.75 16.6228 3.75 12.0664C3.75 7.51006 7.44365 3.81641 12 3.81641C16.5563 3.81641 20.25 7.51006 20.25 12.0664Z"
      stroke="currentColor"
      strokeWidth="1."
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconClock
